import { useCreateEventMutation } from "@app/data/createEvent/api";
import useCredentials from "@utils/useCredentials";
import { CreateEventInfo, SuccessfullyCreateEvent } from "@app/data/createEvent/types";
import { getGMTOffset } from "@utils/timezone.utils";
import { extractErrorMessage } from "@utils/extractErrorMessage.utils";
import { ym } from "@/utils/metrika";
import { logger } from "@app/data/logger/logger";

export interface EventBuilder {
  isLoading: boolean;
  // Возвращает созданное событие или null, если создать не удалось (причина — в onError)
  build: (event: CreateEventInfo) => Promise<SuccessfullyCreateEvent | null>;
}

export interface CreateEventProps {
  onSuccess?: (createdEvent: SuccessfullyCreateEvent) => void;
  onError?: (message: string) => void;
}

export function useCreateEvent(props: CreateEventProps = {}): EventBuilder {
  const [createEvent, { isLoading }] = useCreateEventMutation();
  const credentials = useCredentials();

  const build = async (event: CreateEventInfo): Promise<SuccessfullyCreateEvent | null> => {

    if (!credentials.isAuthenticated) {
      const msg = "Пользователь не авторизован";
      logger.error(msg)
      props.onError?.(msg);
      return null;
    }

    const payload = {
      ...event,
      time_zone: getGMTOffset(),
      organizer_id: Number(credentials.userId),
    };

    try {
      const createdEvent = await createEvent(payload).unwrap();
      ym.createEventSuccess();
      props.onSuccess?.(createdEvent);
      return createdEvent;
    } catch (err) {
      const message = extractErrorMessage(err) || "Не удалось создать событие";
      props.onError?.(message);
      if (process.env.NODE_ENV === 'development') {
        logger.error(message)
      }
      return null;
    }
  };

  return {
    isLoading,
    build,
  };
}
